export const formatDate_DD_MMM_YYYY = (
  dateString: string,
  isComa?: boolean
): string => {
  // return dateString;
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return isComa ? `${day} ${month}, ${year}` : `${day} ${month} ${year}`;
};

export const formatDateToYMD = (dateInput: string) => {
  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return null; // invalid date fallback

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const addDaysToToday = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().split("T")[0];
};

export const formatToDayMonYear = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, "0");

  const monthShort = date.toLocaleString("en-GB", { month: "short" });

  const year = date.getFullYear();
  return `${day}-${monthShort}-${year}`;
};

export const formatDateToReadable = (dateString: string) => {
  const date = new Date(dateString.replace(" ", "T"));

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatLocalDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
